const IconLocation = ({ width, height, size, color, ...props }) => (
    <svg
        width={width || size}
        height={height || size}
        viewBox="0 0 10 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M4.875 0.625C2.1582 0.625 0 2.80859 0 5.5C0 7.48047 0.660156 8.03906 4.36719 13.3711C4.49414 13.5488 4.67188 13.625 4.875 13.625C5.05273 13.625 5.23047 13.5488 5.35742 13.3711C9.06445 8.01367 9.75 7.48047 9.75 5.5C9.75 2.80859 7.56641 0.625 4.875 0.625ZM4.875 11.9492C4.41797 11.3145 4.01172 10.7305 3.65625 10.248C1.44727 7.09961 1.21875 6.69336 1.21875 5.5C1.21875 3.49414 2.84375 1.84375 4.875 1.84375C6.88086 1.84375 8.53125 3.49414 8.53125 5.5C8.53125 6.69336 8.27734 7.09961 6.06836 10.248C5.71289 10.7305 5.30664 11.3145 4.875 11.9492ZM4.875 3.46875C3.73242 3.46875 2.84375 4.35742 2.84375 5.5C2.84375 6.61719 3.73242 7.53125 4.875 7.53125C5.99219 7.53125 6.90625 6.61719 6.90625 5.5C6.90625 4.35742 5.99219 3.46875 4.875 3.46875ZM4.875 6.3125C4.41797 6.3125 4.0625 5.95703 4.0625 5.5C4.0625 5.06836 4.41797 4.6875 4.875 4.6875C5.30664 4.6875 5.6875 5.06836 5.6875 5.5C5.6875 5.95703 5.30664 6.3125 4.875 6.3125Z"
            fill={color}
        />
    </svg>
);

export default IconLocation;
